var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "44px",
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "atoms/icon/action/message") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "atoms/icon/action/message",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32,12 C33.1045695,12 34,12.8954305 34,14 L34,26 C34,27.1045695 33.1045695,28 32,28 L24.375,28 L21.7525767,30.9970552 C21.5898155,31.183068 21.3650182,31.3010963 21.1225193,31.3310225 L21,31.3385506 C20.4477153,31.3385506 20,30.8908353 20,30.3385506 L20,30.3385506 L20,28 L14,28 C12.8954305,28 12,27.1045695 12,26 L12,14 C12,12.8954305 12.8954305,12 14,12 L32,12 Z",
    id: "Combined-Shape",
    stroke: "#3E3A39",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 18,
    x2: 30,
    y2: 18,
    id: "Path-19",
    stroke: "#3E3A39",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 22,
    x2: 30,
    y2: 22,
    id: "Path-19",
    stroke: "#3E3A39",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/messageIcon.463545eb9ec4e5f11a341d8eb6d24e3b.svg";
export { ForwardRef as ReactComponent };